import { Auth, Connect } from '@genesislcap/foundation-comms';
import { DI } from '@microsoft/fast-foundation';
import { RESURETY_REMAP_VERSION } from '../utils';

export interface IThirdPartyService {
  changeResuretyVersion(username: string, version: RESURETY_REMAP_VERSION): Promise<any>;
  loadArteriaUrl(): any;
  openArteriaNegotiations(): void;
  openArteriaChecklist(id: string): void;
}

class ThirdPartyServiceImpl implements IThirdPartyService {
  @Connect private connect: Connect;
  @Auth private auth: Auth;

  private arteriaUrl: any = ""

  public openArteriaNegotiations() {
    window.open(`${this.arteriaUrl}negotiations/`, '_blank').focus();
  }

  public openArteriaChecklist(id: string) {
    window
        .open(
            `${this.arteriaUrl}negotiation/closing-checklist/${id}`,
            '_blank'
        )
        .focus();
  }

  public loadArteriaUrl() {
    if (!this.arteriaUrl) {
      this.connect.request('REQ_ARTERIA_URL', {REQUEST: {}}).then((response) => {
        if (response) {
          this.arteriaUrl = response.REPLY[0]?.ARTERIA_URL
        }
      });
    }
  }

  public async changeResuretyVersion(
    username: string,
    version: RESURETY_REMAP_VERSION
  ): Promise<any> {
    const request: any = await this.connect.commitEvent('EVENT_RESURETY_REMAP_CHANGE_VERSION', {
      DETAILS: { USERNAME: username, RESURETY_REMAP_VERSION: version },
    });
    return request;
  }
}
export const IThirdPartyService = DI.createInterface<IThirdPartyService>((x) =>
  x.singleton(ThirdPartyServiceImpl)
);
